// 验证表单
export function validateForm(formName) {
  return new Promise(resolve => {
    this.$refs[formName].validate(valid => resolve(valid))
  })
}

// 转换数组（一维数组转二维数组）
export function arrConversion(res) {
  let newArr = []
  let n = 8
  let len = res.length
  let carouselLen = len % n === 0 ? len / n : Math.floor(len / n + 1)
  for (let i = 0; i < carouselLen; i++) {
    let temp = res.slice(i * n, i * n + n)
    newArr.push(JSON.parse(JSON.stringify(temp)))
  }
  return newArr
}

// 训练
export function getTime() {
  return parseInt(Date.now() / 1000, 10)
}

export function getDuration(start_time) {
  return parseInt((getTime() - start_time) / 60, 10)
}

// 判断操作系统
export function detectOS() {
  let isWin = navigator.platform.indexOf('Win') !== -1
  let isMac = navigator.platform.indexOf('Mac') !== -1
  if (isMac) return 'mac'
  if (isWin) return 'win'
}
// 判断IE
export function IEVersion() {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) return true
  // let userAgent = navigator.userAgent
  // let isOpera = userAgent.indexOf('Opera') > -1
  // let isIE =
  //   userAgent.indexOf('compatible') > -1 &&
  //   userAgent.indexOf('MSIE') > -1 &&
  //   !isOpera
  // let isEdge = userAgent.indexOf('Trident') > -1 && !isIE
  // if (isIE || isEdge) return true
}

/**
 * @description 判断图片是否加载完成
 */
export function checkImgLoaded(src) {
  return new Promise(resolve => {
    const oImg = document.createElement('img')
    oImg.src = src
    oImg.onload = () => resolve(true)
    oImg.onerror = () => resolve(false)
  })
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a')
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function minAndSecond(value) {
  const min = Math.floor(value / 60)
  const sec = value % 60
  return min + '分' + sec + '秒'
}

export function gender(value) {
  return Number(value) === 0 ? '男' : '女'
}
